import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {Filter} from "./filter";

@Injectable()
export class FilterService {

  // filter
  private filter:Filter = new Filter('', '', '');

  // Observable filter source
  private filterSource = new BehaviorSubject<Filter>(this.filter);

  // Observable filter stream
  filter$ = this.filterSource.asObservable();
}



// WEBPACK FOOTER //
// ./src/app/filter/filter.service.ts